<template>
  <div>
    <el-dialog
      title="网元列表"
      :visible="visible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
    >
      <el-row style="margin-bottom: 20px;">
        <el-col :span="5">
          <el-select v-model="nuType" placeholder="请选择网元类型">
            <el-option
              v-for="item in option"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-col>
        <el-col :span="6" :offset="12">
          <el-input placeholder="输入关键字搜索" prefix-icon="el-icon-search" v-model="search"></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col
          :span="6"
          v-for="(item, index) in networkUnitArray"
          :key="item.id"
          style="margin-bottom:40px"
        >
          <div @click="handleCheckedChange(item, index, $event)" class="divCheckedNetwork">
            <el-card
              :body-style="{ padding: '0px'}"
              :class="['item' + index, {active:item.id == active}]"
              shadow="hover"
              :offset="1"
              style="width: 300px;height: 150px;cursor:pointer;"
            >
              <div style="float: right;z-index:100;padding:10px;">
                <el-badge :value="(index+1)" type="primary"></el-badge>
              </div>
              <unit :item="item" />
            </el-card>
          </div>
        </el-col>
      </el-row>

      <el-collapse v-if="current.id">
          <unit-module-list :unit="current"/>
      </el-collapse>
      
      <el-row style="text-align:center;margin-top:22px;">
          <el-button type="primary" @click="save">确定</el-button>
          <el-button @click="cancelCallback">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import Unit from "./Unit.vue";
import UnitModuleList from "./UnitModuleList.vue"
export default {
  name: "UnitList",
  components: { Unit, UnitModuleList },
  props: {
    visible: {
      type: Boolean
    }
  },
  data: vm => ({
    active: null,
    option: [],
    search: "",
    nuType: null,
    networkUnitArray: [],
    networkUnitArrayBackup: [],
    current: {}
  }),
  created(){
      this.findAll()
  },
  methods: {
    /**
     * 选中网元触发模块
     */
    handleCheckedChange(row, index, e) {
      this.active = row.id;
      this.current = row
      // this.$emit('setModules', row.moduleList);
      // this.$emit('nuType', {id: row.networkUnitTypeId, type: row.networkUnitType});
      // this.$emit('nuVersion', {name: row.name, id: row.id});
    },

    findAll() {
      // this.$axios.get(this.baseUrl + "network/findAll").then(({rows}) => {
      const rows = [
        {
          alias: "UserCenter",
          createTime: 1578448280768,
          description: "test",
          flag: 0,
          id: 1,
          moduleList: [
            {
              id: 1,
              flag: 0,
              createTime: 1578385044760,
              updateTime: 1578385044760,
              name: "NubeNumber_linux"
            },
            {
              id: 2,
              flag: 0,
              createTime: 1578385124710,
              updateTime: 1578385124710,
              name: "oss_linux"
            },
            {
              id: 3,
              flag: 0,
              createTime: 1578385238807,
              updateTime: 1578385238807,
              name: "BaikuUserCenter_linux"
            },
            {
              id: 6,
              flag: 0,
              createTime: 1578386310810,
              updateTime: 1578386310810,
              name: "UnifiedService_linux"
            }
          ],
          name: "UserCenter_20200108",
          networkUnitGroupId: 0,
          networkUnitType: "UserCenter",
          networkUnitTypeId: 1,
          updateTime: 1578448280768,
          version: "20200108"
        }
      ];
      console.log("networkUnitArray--->", rows);
      this.networkUnitArray = rows;
      this.networkUnitArrayBackup = rows;
      let tmp = new Map();
      this.networkUnitArray.forEach(value => {
        if (!tmp.has(value.networkUnitTypeId)) {
          if (value.networkUnitTypeId != 0) {
            tmp.set(value.networkUnitTypeId, value.networkUnitType);
          } else {
            tmp.set(value.networkUnitTypeId, "未定义网元类型");
          }
        }
      });
      this.option = [{ label: "全部", value: -1 }];
      tmp.forEach((value, key) => {
        this.option.push({ label: value, value: key });
      });
      // });
    },
    save(){
        this.current.type = 'unit'
        this.$emit('chooseCallback', this.current)
    },
    cancelCallback(){
      this.$emit('cancelCallback', 'showUnit')
    }
  },
  watch: {
    nuType(val, oldVal) {
      if (val == -1) {
        return (this.networkUnitArray = this.networkUnitArrayBackup);
      }
      this.networkUnitArray = this.networkUnitArrayBackup.filter(
        value => value.networkUnitTypeId == val
      );
    },
    /**
     * 监听 networkUnitImageSearch 网元
     */
    search(val) {
      if (val) {
        this.networkUnitArray = this.networkUnitArrayBackup.filter(data => {
          // return String(data.name).toLowerCase().indexOf(val.toLowerCase()) > -1
          return Object.keys(data).some(key => {
            return (
              String(data[key])
                .toLowerCase()
                .indexOf(val.toLowerCase()) > -1
            );
          });
        });
      } else {
        this.networkUnitArray = this.networkUnitArrayBackup;
      }
    }
  }
};
</script>

<style scoped>
.collapse-title {
  flex: 1 1 auto;
  order: 1;
}
.divCheckedNetwork .active {
  background-color: #409eff;
  border-color: #409eff;
}
</style>